<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ service.name || zone.name }}
        </h1>
        <h1>
          {{ $tc('models.servicePostalCode', 2) }}
<!-- <<<<<<< HEAD
          <v-btn color="primary" @click="goTo('newServicePostalCode')"> {{ $t('create') }} </v-btn>
          <v-btn color="primary" @click="goTo('importServicePostalCodes', { serviceId: $route.params.serviceId })"> {{ $t('importFile') }} </v-btn>
          <v-btn color="primary" @click="exportPostalCodes" v-if="!this.$auth.isAdmin()">{{ $t('exportPostalCodes') }}</v-btn>
======= -->
          <v-btn color="primary" @click="goTo(`new${model}PostalCode`)"> {{ $t('create') }} </v-btn>

          <v-btn color="primary" v-if="$route.path.includes('zone')" @click="goTo(`import${model}PostalCodes`, { zoneId: $route.params.zoneId })"> {{ $t('importFile') }} </v-btn>
          <v-btn color="primary" v-else @click="goTo(`import${model}PostalCodes`, { serviceId: $route.params.serviceId })"> {{ $t('importFile') }} </v-btn>

          <v-btn color="error" @click="deleteAll"> {{ $t('deleteAll') }} </v-btn>
          <v-btn color="primary" outline @click="back"> {{ $t('back') }} </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout wrap>

              <v-flex xs12 md4>
                <v-text-field v-model="search"
                              append-icon="search"
                              :label="$t('search')"
                              @click:append="fetch()"
                              clearable
                              @click:clear="fetch(true)"
                              ></v-text-field>
              </v-flex>

            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-data-table class="elevation-1"
                      :headers="headers"
                      :items="items"
                      :loading="loading"
                      :total-items="totalItems"
                      :pagination.sync="pagination"
                      :no-data-text="$t('noDataAvailable')">
          <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
          <template v-slot:items="props">
            <td> {{ props.item.id }} </td>
            <td> {{ props.item.country.name }} </td>
            <td> {{ props.item.postal_code }} </td>
            <td class="pa-0 pr-2 text-xs-right">
              <v-btn color="red" flat icon @click="destroy(props.item)">
                <font-awesome-icon icon="times"></font-awesome-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Service from '@/client/service'
import Zone from '@/client/zone'
import ServicePostalCode from '@/client/service-postal-code'

export default {
  name: 'ServicePostalCodesView',

  props: {},

  data () {
    return {
      headers: [
        { text: '#', align: 'left', sortable: true, value: 'id', width: '5%' },
        { text: this.$tc('models.country'), align: 'left', sortable: true, value: 'name' },
        { text: this.$t('attrs.postal_code'), align: 'left', sortable: true, value: 'code' },
        { text: '', align: 'left', sortable: false, value: '' }
      ],
      items: [],
      totalItems: 0,
      pagination: {
        rowsPerPage: 10
      },
      loading: false,
      service: {},
      zone: {},
      search: '',
      model: ''
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async fetch (clear = false) {
      if (!this.service.id && !this.zone.id) { return }
      this.loading = true

      const { sortBy, descending, page, rowsPerPage } = this.pagination
      const where = this.$route.path.includes('zone') ? { zone_id: this.zone.id } : { service_id: this.service.id };
      if (this.search && !clear) {
        where.postal_code = this.search
      }
      let order = ''
      if (sortBy) {
        order = `${sortBy} ${descending ? 'desc' : 'asc'}`
      }

      this.items = await ServicePostalCode.all({
        page,
        per_page: rowsPerPage,
        order,
        include: 'country',
        where
      })

      this.totalItems = this.items.pagination.total_objects
      this.loading = false
    },

    async destroy (pc) {
      try {
        await ServicePostalCode.destroyById(pc.id)
      } catch (err) {
        // empty
      }
      this.fetch()
    },

    async deleteAll () {
      const confirm = await this.$root.$confirm.open(this.$t('deleteAll'), this.$t('areYouSure?'), { color: 'red' })
      if (confirm) {
        try {
          if(this.$route.path.includes('zone')) {
            await ServicePostalCode.deleteZonePostalCodes(this.$route.params.zoneId)
          }
          else {
            await ServicePostalCode.deleteAll(this.$route.params.serviceId)
          }

        } catch (err) {
          // empty
        }
        this.fetch()
      }
    },

    async exportPostalCodes () {
      try {
        const data = await Service.exportServicePostals(this.$route.params.serviceId)
        this.downloadFile(data, `${this.service.id}-${this.service.name.replace(/\s+/g, '')}-postal-codes.xlsx`)
      } catch (err) {
        this.handleBlobErr(err)
      }
    },

    handleBlobErr (err) {
      const self = this
      if (err.response) {
        const blob = err.response.data
        const reader = new FileReader()

        reader.addEventListener('loadend', (e) => {
          const text = e.srcElement.result
          self.handleErr({ response: { data: JSON.parse(text) } })
        })

        reader.readAsText(blob)
      } else {
        this.handleErr(err)
      }
    },

    downloadFile (data, filename) {
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },

  watch: {
    pagination: {
      handler () {
        this.fetch()
      },
      deep: true
    }
  },

  async mounted () {
    if (this.$route.path.includes('zone')) {
      this.model = 'Zone'
      this.zone = await Zone.findOne(this.$route.params.zoneId)
    }
    else{ 
      this.model = 'Service'
      this.service = await Service.findOne(this.$route.params.serviceId)
    }
    this.fetch()
  }
}
</script>